import Phaser, {
    Scene
} from 'phaser'
import {
    CST
} from '../CST'
import $ from "jquery"


var clickSound;
var timerSound;
var correctSound;
var wrongSound;
var questions = new Array();
var current_question;
var question_index;
var time_timer;
var timer_text;
var time_left;
var time_up;
var end;
var showing;
var time_up_img;
var answer;
var pop_up_question;
var pop_up_answer;

export default class QuestionScene extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.QUESTION)
    }

    init() {
        question_index = 0;
        end = false;
        answer = true;
        time_up = false;
        showing = false;
    }

    preload() {
        loadQuestionsFromDatabase();
        //questions = randomiseQuestions(questions);
    }

    create(data) {

        // BACKGROUND AND VISUALS

        clickSound = this.sound.add("clickSound", {
            volume: 0.75
        });
        timerSound = this.sound.add("timerSound", {
            volume: 0.75
        });
        correctSound = this.sound.add("correctSound", {
            volume: 0.5
        });
        wrongSound = this.sound.add("wrongSound", {
            volume: 0.5
        });

        current_question = nextQuestion();

        const boardScene = this.scene.get(data.scene);

        if (this.textures.exists("question_card")) this.textures.remove("question_card")
        this.load.image("question_card", current_question.question).start();
        this.load.on("complete", () => {
            pop_up_question = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'question_card');
            answer = false;
        });

        if (this.textures.exists("answer_card")) this.textures.remove("answer_card")
        this.load.image("answer_card", current_question.feedback).start();
        this.load.on("complete", () => {
            pop_up_answer = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'answer_card').setVisible(false);

            time_up_img = this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2), "time_up").setScale(0.8);
            time_up_img.setVisible(false);

            timer_text = this.add.text(this.cameras.main.width / 2 + 290, (this.cameras.main.height / 2) - 335, "30", CST.TEXTSTYLES.TIMERSTYLE);
            time_left = 30;
            time_timer = this.scene.scene.time.now;

            answer = false;
            var show_answer = this.add.image(this.cameras.main.width / 2, (this.cameras.main.height / 2) + 336, 'btn_show_answer');
            show_answer.setInteractive({
                useHandCursor: true
            });
            show_answer;
            show_answer.on("pointerdown", () => {
                clickSound.play();
                timerSound.stop();
                show_answer.setVisible(false);
                tick.setVisible(true);
                cross.setVisible(true);
                pop_up_question.setVisible(false);
                pop_up_answer.setVisible(true);
                time_up_img.setVisible(false);
                timer_text.setVisible(false)
                answer = true;
                showing = false;
            });

            const tick = this.add.image(this.cameras.main.width / 2 + 100, this.cameras.main.height / 2 + 336, 'tick').setVisible(false).setInteractive({
                useHandCursor: true
            });
    
            const cross = this.add.image(this.cameras.main.width / 2 - 100, this.cameras.main.height / 2 + 336, 'cross').setVisible(false).setInteractive({
                useHandCursor: true
            });
    
            tick.on("pointerdown", () => {
                clickSound.play();
                correctSound.play();
    
                current_question = nextQuestion();
    
                pop_up_question.destroy();
                this.textures.remove("question_card");
    
                pop_up_answer.destroy();
                this.textures.remove("answer_card");
    
                this.load.image("question_card", current_question.question).start();
                pop_up_question.setVisible(true);
    
                this.load.image("answer_card", current_question.feedback).start();
                pop_up_answer.setVisible(false);
    
                show_answer.setVisible(true);
                pop_up_answer.setVisible(false);
                pop_up_question.setVisible(true);
                timer_text.setVisible(true);
                tick.setVisible(false);
                cross.setVisible(false);
                time_up = false;
                answer = false;
                time_left = 30;
                this.scene.pause();
                this.scene.resume(boardScene.scene.key, {
                    type: 0,
                    data: 0,
                    points: 1,
                    end: end,
                    scene: CST.SCENES.QUESTION
                });
                this.scene.sendToBack();
            });
    
    
            cross.on("pointerdown", () => {
                clickSound.play();
                wrongSound.play();
    
                current_question = nextQuestion();
    
                pop_up_question.destroy();
                this.textures.remove("question_card");
    
                pop_up_answer.destroy();
                this.textures.remove("answer_card");
    
                this.load.image("question_card", current_question.question).start();
                pop_up_question.setVisible(true);
    
                this.load.image("answer_card", current_question.feedback).start();
                pop_up_answer.setVisible(false);
    
                show_answer.setVisible(true);
                pop_up_answer.setVisible(false);
                pop_up_question.setVisible(true);
                tick.setVisible(false);
                cross.setVisible(false);
                timer_text.setVisible(true)
                time_up = false;
                answer = false;
                time_left = 30;
                this.scene.pause();
                this.scene.resume(boardScene.scene.key, {
                    type: 0,
                    data: 1,
                    end: end,
                    scene: CST.SCENES.QUESTION
                });
                this.scene.sendToBack();
            });
        });


        
    }

    update() {
        if (!answer) {
            updateTimeText(this);
        }
    }
}

function loadQuestionsFromDatabase() {
    var websiteBaseUrl = "website/";
    $.ajax({
        async: false,
        type: "get",
        url: websiteBaseUrl + 'get-questions-to-json.php',
        dataType: 'JSON',
        success(data) {
            questions = data;
        }
    }).responseJSON;
};


function randomiseQuestions(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
};

function nextQuestion() {
    if (question_index != questions.length) {
        current_question = questions[question_index];
        question_index++;
        return current_question;
    } else {
        questions = randomiseQuestions(questions);
        question_index = 0;
        current_question = questions[question_index];
        question_index++;
        end = true;
        return current_question;
    }
}

function updateTimeText(scene: Scene) {
    if (!time_up) {
        if (time_timer + 1000 <= scene.scene.scene.time.now) {
            time_left -= 1;
            if (time_left <= 0) time_up = true;
            if (time_left == 5) timerSound.play();
            timer_text.text = time_left;
            if (time_left < 10) timer_text.text = " " + timer_text.text; 
            time_timer = scene.scene.scene.time.now;
        }
    } else {
        if (!showing) {
            showing = true
            time_up_img.setVisible(true);
            setTimeout(() => {
                time_up_img.setVisible(false);
            }, 3000);
            timerSound.stop();
        }
    }
};